import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoshirdicab() {



const cardData = {
  keyword: " Mumbai to Shirdi Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Shirdi cab services, ensuring a smooth and hassle‑free journey to one of India’s most revered pilgrimage destinations. Our professional drivers, well‑maintained vehicles, and punctual pickups make traveling from Mumbai to Shirdi convenient and stress‑free. We offer flexible booking options including one‑way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and groups. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for your Mumbai to Shirdi cab travel.",

topPlaces: [
  {
    title: "Shirdi Sai Baba Temple",
    description: "The Shirdi Sai Baba Temple is the primary spiritual attraction in Shirdi and one of the most visited pilgrimage sites in India. Travelers from Mumbai can take a cab directly to the temple to participate in daily darshan, aarti ceremonies, and special rituals. The serene atmosphere and devotional energy make this temple a significant destination for devotees seeking blessings and spiritual peace."
  },
  {
    title: "Dwarkamai Mosque",
    description: "Dwarkamai Mosque is an important spiritual site in Shirdi where Sai Baba lived for many years. Travelers arriving from Mumbai by cab can visit this sacred place to explore the historic mosque, witness daily prayers, and experience the devotional ambiance. The site holds immense religious significance and is an integral part of the Shirdi pilgrimage."
  },
  {
    title: "Chavadi",
    description: "Chavadi is a historic location in Shirdi where Sai Baba used to spend alternate nights with his devotees. Travelers from Mumbai can include Chavadi in their itinerary to observe the evening and early morning rituals and listen to devotional stories. The peaceful surroundings and spiritual activities make it a meaningful stop during the visit."
  },
  {
    title: "Lendi Baug",
    description: "Lendi Baug is a serene garden in Shirdi where Sai Baba used to walk and meditate. Cab travelers from Mumbai can enjoy a peaceful stroll through the lush garden, visit the pond, and spend quiet moments in reflection and prayer. It’s a tranquil spot that offers calm and scenic beauty amidst a spiritually uplifting journey."
  },
  {
    title: "Sai Heritage Village",
    description: "Sai Heritage Village is a cultural theme park near Shirdi that offers insight into the life and times of Sai Baba through exhibits, replicas, and interactive displays. Travelers using a cab from Mumbai can explore this attraction to learn about Sai Baba’s legacy, enjoy cultural performances, and take family‑friendly photos in a well‑designed environment."
  },
  {
    title: "Wet N Joy Water Park",
    description: "Wet N Joy Water Park is a popular recreational destination located near Shirdi, ideal for families and travelers seeking fun and relaxation. Those arriving from Mumbai by cab can enjoy water slides, wave pools, and adventure rides. The park is perfect for a refreshing break, especially on hot days after devotional visits."
  },
  {
    title: "Sai Teerth Theme Park",
    description: "Sai Teerth Theme Park is a spiritual amusement park that combines devotion with entertainment, featuring life‑sized exhibits depicting episodes from Sai Baba’s life. Cab travelers from Mumbai can explore the park to experience cultural shows, thematic displays, and interactive experiences that highlight Sai Baba’s teachings."
  },
  {
    title: "Shani Shingnapur Temple",
    description: "Located near Shirdi, Shani Shingnapur Temple is dedicated to Lord Shani and is renowned for its open‑house deity and unique tradition of no doors in the village homes. Travelers from Mumbai can take a cab to this temple to seek blessings, witness unique practices, and explore the village renowned for its devotional culture."
  },
  {
    title: "Nashik City",
    description: "Nashik City is a major nearby urban center and cultural hub that travelers from Mumbai to Shirdi can visit by extending their cab trip. Visitors can explore places like Sula Vineyards, Panchavati, and Ramkund, enjoy local cuisine, and take part in cultural experiences. Nashik adds a rich dimension to the pilgrimage journey with its historic and scenic attractions."
  },
  {
    title: "Shridi Fruit Market",
    description: "The Shirdi Fruit Market is a vibrant local spot where travelers can shop for fresh fruits, juices, and regional produce. Cab travelers from Mumbai can visit this market to enjoy local flavors, purchase seasonal fruits, and interact with residents. It’s a great stop for those looking to experience local life and food during their Shirdi pilgrimage."
  }
],



services: [
{
name: "Mumbai to Shirdi Cab Service",
description: "Mumbai to Shirdi cab service offers a comfortable and convenient journey to the holy town of Shirdi, home to the revered Sai Baba Temple. This service is ideal for devotees, families, and groups planning a peaceful pilgrimage from Mumbai. The route includes smooth highways and scenic landscapes, ensuring a relaxing travel experience. Professional drivers experienced in long-distance routes ensure safe and timely arrival for darshan. Customers can choose from sedan, SUV, and premium vehicles based on their group size and comfort preference. Flexible pickup options from home, airport, or railway station make the journey hassle-free. With transparent pricing, easy booking, and 24x7 availability, this cab service ensures a smooth and divine travel experience."
},
{
name: "Mumbai to Shirdi Taxi",
description: "Mumbai to Shirdi taxi service provides reliable and comfortable transportation for devotees traveling to Sai Baba Temple. Well-maintained vehicles and experienced drivers ensure a safe journey across highways. This service is suitable for one-day trips as well as extended stays. Travelers can enjoy door-to-door pickup and flexible travel timings. Multiple vehicle options are available for different budgets and group sizes. With affordable pricing and easy booking, this taxi service ensures a stress-free pilgrimage."
},
{
name: "One Way Cab Mumbai to Shirdi",
description: "One way cab Mumbai to Shirdi is a cost-effective option for travelers who need a single-side drop without return charges. This service is ideal for those planning to stay in Shirdi or continue their journey further. Customers benefit from competitive pricing, flexible pickup timing, and comfortable vehicles. Professional drivers ensure timely arrival and safe driving. Sedan and SUV options are available based on travel needs. Easy online booking and instant confirmation make it highly convenient."
},
{
name: "Mumbai to Shirdi Taxi Fare",
description: "Mumbai to Shirdi taxi fare is designed to be transparent and budget-friendly, helping travelers plan their journey effectively. Pricing varies based on vehicle type, distance, and duration. Customers receive clear cost breakdowns including tolls and driver allowances where applicable. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. It offers excellent value for a comfortable pilgrimage trip."
},
{
name: "Mumbai to Shirdi Cab Booking Online",
description: "Mumbai to Shirdi cab booking online allows travelers to easily reserve their cab with instant confirmation and flexible scheduling. Customers can select vehicle types, pickup locations, and travel dates based on their needs. Transparent pricing ensures no hidden costs during the journey. Online platforms provide secure payment and quick booking options. Dedicated support is available for assistance before and during travel. It is the most convenient way to plan your Shirdi visit."
},
{
name: "Cheap Cab Mumbai to Shirdi",
description: "Cheap cab Mumbai to Shirdi provides budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers who want reliable transportation at affordable rates. Economical sedan options are available for lower fares. Transparent pricing and no hidden charges make this service highly popular. Professional drivers ensure safe travel. It is a perfect balance of affordability and comfort."
},
{
name: "Mumbai to Shirdi Outstation Cab",
description: "Mumbai to Shirdi outstation cab service offers long-distance travel with comfort and reliability for temple visits. This service is ideal for pilgrims and tourists seeking a smooth journey. Vehicles are well-maintained for safety and performance on highways. Flexible pickup options and travel schedules add convenience. Travelers can choose between one way and round trip packages. It ensures a hassle-free travel experience."
},
{
name: "AC Taxi Mumbai to Shirdi",
description: "AC taxi Mumbai to Shirdi ensures a comfortable journey in air-conditioned vehicles, especially during long-distance travel. This service provides a pleasant environment inside the vehicle regardless of weather conditions. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for families, tourists, and corporate travelers. Flexible pickup options add convenience. It guarantees a relaxing travel experience."
},
{
name: "Private Cab Mumbai to Shirdi",
description: "Private cab Mumbai to Shirdi offers a personalized travel experience with exclusive vehicle usage for families and groups. Travelers can customize routes, stops, and travel schedules based on their preferences. This ensures a relaxed and stress-free journey. Professional drivers provide safe and reliable service throughout the trip. Comfortable seating and premium service enhance the experience. It is ideal for a private and peaceful pilgrimage."
},
{
name: "Mumbai to Shirdi Round Trip Cab",
description: "Mumbai to Shirdi round trip cab service is ideal for travelers planning a return journey after darshan. This package includes pickup, drop, waiting time, and return travel with flexible schedules. Travelers can complete darshan without worrying about return transport. Professional drivers ensure timely service and safe driving. Multiple vehicle options are available for families and groups. It offers convenience, comfort, and cost efficiency."
},
{
name: "Mumbai to Shirdi SUV Taxi",
description: "Mumbai to Shirdi SUV taxi is ideal for group travel and those seeking extra space and comfort during long journeys. SUVs provide spacious seating and better performance on highways. This option is suitable for families, friends, and corporate groups. Drivers are experienced in long-distance routes ensuring safety. It offers a premium and comfortable travel experience. Perfect for pilgrimage and group trips."
}
],

tableData: [
["Mumbai to Shirdi Cab Service","Mumbai to Shirdi Taxi"],
["One Way Cab Mumbai to Shirdi","Mumbai to Shirdi Taxi Fare"],
["Mumbai to Shirdi Cab Booking Online","Cheap Cab Mumbai to Shirdi"],
["Mumbai to Shirdi Outstation Cab","AC Taxi Mumbai to Shirdi"],
["Private Cab Mumbai to Shirdi","Mumbai to Shirdi Round Trip Cab"],
["Mumbai to Shirdi SUV Taxi","Mumbai to Shirdi Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Pilgrimage Travel",
    WhyChoosedescription: "Velocity Cabs offers reliable Mumbai to Shirdi cab service, ideal for devotees visiting Sai Baba Temple with a smooth, peaceful, and comfortable travel experience."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance routes between Mumbai and Shirdi, ensuring safe driving, smooth navigation, and timely darshan planning."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai to Shirdi cab bookings. Customers receive complete fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Shirdi cab service operates 24/7. Whether you plan early morning darshan or overnight travel, Velocity Cabs ensures reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and stress-free long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, same-day return trips, and multi-day round-trip packages for Shirdi darshan."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group pilgrimage travel."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many devotees for Mumbai to Shirdi cab bookings due to punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Shirdi cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai to Shirdi for one-way and round-trip travel." },
  { question: "How far is Shirdi from Mumbai?", answer: "The distance between Mumbai and Shirdi is approximately 240 km and the journey takes around 5 to 6 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Shirdi cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Shirdi." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Shirdi cabs online or through phone booking." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, railway stations, and airports across Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and festival seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prasad Kulkarni",
    feedback:
      "A peaceful and comfortable journey from Mumbai to Shirdi. The cab was well-maintained, and the long drive felt smooth and spiritually uplifting throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Mumbai to Shirdi cab service was very reliable and well-organized. The vehicle was clean, the ride was steady, and the entire pilgrimage trip felt stress-free.",
    rating: 5
  }
];




























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const mumbaiShirdiJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Shirdi Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Shirdi for a convenient outstation trip. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Shirdi Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Shirdi",
        "description": "Private cab from Mumbai to Shirdi for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Shirdi Cab",
        "description": "Comfortable round-trip cab service from Mumbai to Shirdi with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};







  return (
    <div>
      
<Helmet>
  <title>Mumbai to Shirdi Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Shirdi for a convenient outstation trip. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiShirdiJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoshirdicab;